import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { type DomicileDto, getEnabledDomiciles } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useEnabledDomiciles(): UseQueryResult<DomicileDto[], AxiosError> {
    const queryKey = useMemo(() => queryKeys.enabledDomiciles(), []);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getEnabledDomiciles({ signal }).then((result) => result.data),
    });
}
